import { useQuery } from '@tanstack/react-query';

import { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';

import { FlowClient } from '@@api';
import { useApiClient } from '@@common';

import { FlowRefModel } from '../../Models/DomainServiceModel';
import ListWithFilter from '../ListWithFilter';

type FlowInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	flowRef: FlowRefModel | undefined;
	onFlowRefChange: (flowRef: FlowRefModel | undefined) => void;
};

export function FlowInputDialog({ open, setOpen, flowRef, onFlowRefChange }: FlowInputDialogProps) {
	const flowClient = useApiClient(FlowClient);
	const { data } = useQuery({
		queryKey: ['flows', 'search'],
		queryFn: () => flowClient.search(0, 1000, 'name', true, undefined, undefined, undefined),
		staleTime: 10000,
	});

	const flows = data?.items ?? [];
	const [selectedId, setSelectedId] = useState<string | undefined>(flowRef?.Id);

	useEffect(() => {
		if (open) setSelectedId(flowRef?.Id);
	}, [open, flowRef?.Id]);

	const handleClose = () => setOpen(false);

	const handleSave = () => {
		const selected = flows.find((f) => f.id === selectedId);
		onFlowRefChange(selected ? { Id: selected.id, Name: selected.name } : undefined);
		setOpen(false);
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle>Select Flow</DialogTitle>
			<DialogContent dividers>
				<Stack direction="column" height="70vh">
					<ListWithFilter
						items={flows}
						selectedItemId={selectedId}
						onSelected={(item) => setSelectedId(item.id)}
						getKey={(item) => item.id}
						getDisplayName={(item) => item.name}
						placeholder="Search flows"
						sx={{ width: '100%', overflowY: 'auto', flexGrow: 1 }}
					/>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSave}>Save</Button>
			</DialogActions>
		</Dialog>
	);
}
